export const ABIERTO = 'ABIE'
export const CERRADO = 'CERR'

export const __dictionary = {
  [ABIERTO]: {
    id: ABIERTO,
    nombre: 'ABIERTO'
  },
  [CERRADO]: {
    id: CERRADO,
    nombre: 'CERRADO'
  }
}

export const __array = [__dictionary[ABIERTO], __dictionary[CERRADO]]
